export default __webpack_public_path__ + "static/media/kliznekapije2.a1abf9e8.png";